import React from "react";
import PropTypes from "prop-types";
import { getDate } from "common/utils/dateUtil";
import {
    STATUS_CANCELLED,
    STATUS_EXPIRED
} from "common/constants/Constants";
import styles from "./styles.module.scss";

const SubscriptionEndDate = ({ status, endDate }) => {
    if (status !== STATUS_CANCELLED && status !== STATUS_EXPIRED) {
        return null;
    }

    return (
        <div className={ styles.endDate }>
            <span className={ styles.label }>End Date: </span>
            <span className={ styles.text }>{ getDate(endDate) }</span>
        </div>
    );
};

SubscriptionEndDate.propTypes = {
    status: PropTypes.string.isRequired,
    endDate: PropTypes.string
};

export default SubscriptionEndDate;
